/* @flow */

import {type ColorName} from 'shells/colors';

export type FeedbackSurvey = {|
    id: string,
    pathNames: Array<string>,
    bannerTitle: string,
    surveyTitle: string,
    surveySubtitle: string,
    expireDate?: string,
    feedbackPrompt?: string,
    surveyImage?: string,
    surveyImageBackgroundColor?: ColorName,
|};

/*
    - use * as a wildcard to match certain dynamic paths (ex: /lead/* would match /lead/123, /lead/456, etc.)
    - use \n to create line breaks in the surveyTitle and surveySubtitle
*/
export const FEEDBACK_SURVEYS: Array<FeedbackSurvey> = [
    {
        id: 'tasks-report',
        pathNames: ['/reports/tasks'],
        bannerTitle: 'Track your team’s performance with our new tasks report',
        surveyTitle: 'Tell us what you think about the new tasks report',
        surveySubtitle:
            'Did you find the tasks report helpful?\nHow does your team track your sales process performance?\nIs there anything missing from this report you’d like to see?',
        surveyImage: '/include/images/onboarding/tasks-report.svg',
    },
    {
        id: 'product-categories',
        pathNames: ['/sales/product', '/sales/product/categories'],
        bannerTitle: 'Product categories are now available',
        surveyTitle: 'Tell us what you think about product categories',
        surveySubtitle:
            'Did you find the addition of product categories helpful?\nAre there additional features or functionality your team could benefit from being added to product categories?',
        surveyImage: '/include/images/onboarding/product-category-illustration.svg',
    },
];
